import React from "react";
import styles from "./PanelUpdatedData.module.css";
import Button from "../Button";
import { useLocalization } from "../../../context/LocalizeContextProvider";

export default function PanelUpdatedData({
  updatedAt,
  updatedBy,
  onClickEdit = () => undefined,
  isEdit = false,
}) {
  const localize = useLocalization();

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.timeSection}>
          <i className={`far fa-clock ${styles.icon}`}></i>
          <p className={styles.text}>Terakhir Diperbarui :</p>
          <p className={styles.text}>{updatedAt}</p>
        </div>
        {updatedBy && (
          <>
            <div className={styles.divider} />
            <div className={styles.userSection}>
              <i className={`far fa-user ${styles.icon}`}></i>
              <p className={styles.text}>Diperbarui Oleh :</p>
              <p className={styles.text}>{updatedBy}</p>
            </div>
          </>
        )}
      </div>

      {isEdit && (
        <Button
          label={localize.getText("edit")}
          size="sm"
          leftIcon={<i className="fas fa-edit"></i>}
          onClick={onClickEdit}
        />
      )}
    </div>
  );
}
